import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

class CAMCFundDistributorTable {
    constructor(fundCode) {
        this.fundCode = fundCode;
        this.httpClient = new HttpClient();
    }

    async render() {
        const distributors_api = FUND_API_SOURCES.DISTRIBUTORS_SOURCE + this.fundCode;
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
        };
        const distributors_data = await this.httpClient.get(distributors_api, options);
        this.renderFundDistributorTable(distributors_data);
    }

    renderFundDistributorTable(fundDistributorsData) {
        //pass
    }

    errorHandler() {
        //pass
    }
}

export default CAMCFundDistributorTable;
